import { FC, useEffect, useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

import './styles.scss';

type GoogleRecaptchaPropsType = {
  onChange: (value: string) => void;
  isReset: boolean;
};

const GoogleRecaptcha: FC<GoogleRecaptchaPropsType> = ({ onChange, isReset }) => {
  const recaptchaRef = useRef(null);

  useEffect(() => {
    if (
      !recaptchaRef.current ||
      !recaptchaRef.current.props ||
      !recaptchaRef.current.props.grecaptcha
    ) {
      return;
    }

    if (!isReset) {
      recaptchaRef.current.props.grecaptcha.reset();
    }
  }, [isReset]);

  return (
    <ReCAPTCHA
      className="clik-account-google-captcha"
      ref={recaptchaRef}
      type="image"
      sitekey={process.env.REACT_APP_GOOGLE_CAPTCHA_KEY}
      onChange={(value: string) => {
        if (onChange) onChange(value);
      }}
    />
  );
};

export default GoogleRecaptcha;
